import axios from "./axios";

class HistoryService {
  wallet = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page
  ) => {
    try {
      const response = await axios.post("/history/wallet", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  recharge = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page
  ) => {
    try {
      const response = await axios.post("/history/recharge", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  billPayment = async (
    from_date,
    to_date,
    search_text,
    is_init_state,
    size,
    page
  ) => {
    try {
      const response = await axios.post("/history/bbps", {
        from_date,
        to_date,
        search_text,
        is_init_state,
        size,
        page,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new HistoryService();
